var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center d-block w-100"},[_c('b-iconstack',{attrs:{"font-scale":"3.5"}},[_c('b-icon',{staticStyle:{"color":"#0069A9"},attrs:{"stacked":"","icon":"cart2"}})],1),_c('p',[_vm._v(" Oops! Su carrito está vacío, por favor agregue planes desde la pantalla de \"Planes dentales\" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }